import { Injectable } from '@angular/core';

import { MainService } from '../main/main.service';
import { PushNotifications, PushResponse } from '../models';

/**
 * view service for drupal using push_notifications module
 *
 * @see https://www.drupal.org/project/push_notifications
 */
@Injectable()
export class PushNotificationsService extends MainService {
  override entityType = 'push_notifications';

  /**
   * create/register new device with a token
   *
   * @param pushNotifications notification object to register
   */
  create(pushNotifications: PushNotifications): Promise<PushResponse> {
    return this.post(pushNotifications);
  }

  /**
   * delete a subscription by device token
   *
   * @param token token of the device to be deleted
   */
  delete_push(token: string): Promise<PushResponse> {
    return this.delete(token);
  }

}
